import { useApolloClient } from '@apollo/client';
import { useCallback, useEffect } from 'react';
import { useSessionManagement } from '../../session/hooks/useSessionManagement';
import { useLogReportedRefreshError } from '../withAuth/hooks/useLogReportedRefreshError';
import { SessionErrorType } from '../../constants';

export enum SessionActionReason {
    BANNER_CLICKED = 'Log back in banner clicked',
    REFRESH_FAILED = 'Refresh failed',
    SESSION_EXPIRED = 'Session expired',
}

export const MAC_LOAN_ID_KEY = 'MortgageApplicationCenterSelectedLoan';
export const REFRESH_ERROR_MESSAGE = 'There was an issue refreshing your session. You will now be signed out.';
export const useSessionWatcherState = () => {
    const apollo = useApolloClient();

    const { endSession, session } = useSessionManagement();
    useLogReportedRefreshError(session);
    const onLogout = useCallback(async () => {
        await apollo.clearStore();
    }, [apollo]);

    useEffect(() => {
        const guardAgainstRefreshFailures = async () => {
            if (session?.error?.type === SessionErrorType.REFRESH_TOKEN_EXPIRED) {
                return endSession(SessionActionReason.SESSION_EXPIRED, {
                    callbackUrl: window.location.pathname + window.location.search,
                    errorMessage: 'Your session has expired. Please log back in.',
                });
            }
            if (session?.error) {
                endSession(SessionActionReason.REFRESH_FAILED, {
                    callbackUrl: window.location.pathname + window.location.search,
                });
            }
        };
        guardAgainstRefreshFailures();
    }, [endSession, session?.error]);

    return { onLogout, session };
};
